import account from './account'
import mall from './mall'

export default {
  account,
  mall
}
